import {
    GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS,
    GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED,
    RESET_GETCOMMONCONFIGURATIONDETAILSADMIN,
    LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN,
    NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN,
} from "../types/index";

import { adminServices } from "../../config/axios";

const resetGetCommonConfigurationAdmin = () => {
    return { type: RESET_GETCOMMONCONFIGURATIONDETAILSADMIN };
};

const getCommonConfigurationAdminList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN });
        await adminServices
            .post("getCommonConfigurationDetailsAdmin", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getCommonConfigurationAdminSuccess(res.data));
                        break;
                    default:
                        dispatch(getCommonConfigurationAdminFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN,
                    payload: err,
                });
            });

        function getCommonConfigurationAdminSuccess(data) {
            return {
                type: GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS,
                payload: data,
            };
        }

        function getCommonConfigurationAdminFailed(data) {
            return {
                type: GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED,
                payload: data,
            };
        }
    };
export { resetGetCommonConfigurationAdmin, getCommonConfigurationAdminList };